export const order_Loading_status = "order_Loading_status";

export const order_Get_Success_status = "order_Get_Success_status";

export const order_Error_status = "order_Error_status";




